import React from 'react'
import { LoginSocialGoogle } from 'reactjs-social-login';
import Google from '../../../../../assets/images/icon-google.svg';

const GoogleLogin = ({ setSocialSignInData }) => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    return (
        <LoginSocialGoogle
            client_id={clientId}
            scope='openid profile email'
            onResolve={({data}) => {
                setSocialSignInData(data);
            }}
            onReject={(err) => {
                console.log("Google error response ==>>", err)
            }}
        >
            <span className="sso-login"><img src={Google} alt="" /></span>
        </LoginSocialGoogle>
    )
}

export default GoogleLogin;